import type { ReactNode } from 'react';
import { motion } from 'framer-motion';

interface UtilityCardProps {
  label: string;
  icon: ReactNode;
  onClick: () => void;
  isComingSoon?: boolean;
}

export function UtilityCard({ label, icon, onClick, isComingSoon = false }: UtilityCardProps) {
  return (
    <motion.button
      whileHover={isComingSoon ? {} : { scale: 1.05, y: -1 }}
      whileTap={isComingSoon ? {} : { scale: 0.95 }}
      onClick={isComingSoon ? undefined : onClick}
      disabled={isComingSoon}
      className={`flex items-center space-x-2 px-4 py-2.5 rounded-full border text-xs font-bold tracking-wider uppercase transition-all duration-300 shadow-md ${
        isComingSoon
          ? 'bg-slate-950/20 border-white/5 text-surface-600 cursor-not-allowed opacity-50'
          : 'bg-slate-900/30 hover:bg-slate-900/60 border-white/5 hover:border-white/15 text-surface-200 hover:text-white cursor-pointer'
      }`}
    >
      <span className="text-sm">{icon}</span>
      <span>{label}</span>
      {isComingSoon && (
        <span className="text-[8px] font-black bg-slate-950/50 border border-white/5 text-surface-500 px-1.5 py-0.5 rounded-full uppercase tracking-tighter">
          Soon
        </span>
      )}
    </motion.button>
  );
}
